module.exports = __webpack_public_path__ + "static/media/plan-drawing-product.a2425fa7.jpg";